import LogoFull from 'assets/images/logo-full.png'
import { PathsEnum } from 'pages/Paths'
import { FaTrademark } from 'react-icons/fa'
import { Link } from 'react-router-dom'
import styled from 'styled-components'
import { IChildrenNode } from 'types/propTypes'
import { BackgroundMain } from '../BackgroundMain'
import { Copyright } from '../Copyright'
import { LangEnum } from 'configs/lang'

const AccountLayout = ({ children }: IChildrenNode) => {
  return (
    <Div>
      <BackgroundMain />
      <section className="title-and-logo">
        <section>
          <span>
            {LangEnum.claims} {LangEnum.work}
          </span>
          <span></span>
          <span>
            <FaTrademark size={12} />
          </span>
          <span>Console</span>
        </section>
        <Link to={PathsEnum.root}>
          <img src={LogoFull} alt="Logo" title="Outbound AI" width="202" height="27" />
        </Link>
      </section>
      {children}
      <Copyright />
    </Div>
  )
}

const Div = styled.div`
  position: relative;
  min-height: 100vh;
  min-width: 100vh;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  ${({ theme }) => theme.typography.m.normal};
  line-height: ${({ theme }) => theme.util.pixelToRem(19)};

  .title-and-logo {
    position: fixed;
    width: 100%;
    top: ${({ theme }) => theme.util.pixelToRem(80)};
    padding: 0 ${({ theme }) => theme.util.pixelToRem(100)} 0 ${({ theme }) => theme.util.pixelToRem(100)};
    display: flex;
    align-items: center;
    justify-content: space-between;

    ${({ theme }) => theme.typography.h4.normal};
    & span:first-child {
      font-weight: ${({ theme }) => theme.fontWeight.bold};
      color: ${({ theme }) => theme.colors.primary.darker};
    }
    & span:nth-child(2) {
      font-weight: ${({ theme }) => theme.fontWeight.bold};
      color: ${({ theme }) => theme.colors.primary.neutral};
    }

    & span:nth-child(3) {
      display: inline-block;
      transform: translateY(-35%);
      color: ${({ theme }) => theme.colors.primary.darker};
    }
    & span:nth-child(4) {
      margin-left: 0.5rem;
      color: ${({ theme }) => theme.colors.primary.darker};
    }
  }

  footer {
    position: fixed;
    bottom: ${({ theme }) => theme.util.pixelToRem(48)};
    color: ${({ theme }) => theme.colors.primary.neutral};
  }
`
export { AccountLayout }
